module.exports = __webpack_public_path__ + "static/media/icon-no-photos.e7241868.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-no-photos.svg
// module id = 377
// module chunks = 0